import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { connect, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import * as userActions from "../../../actions/index";

const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
const school_code = user_info?.school_code === null || user_info === null ? "" : user_info.school_code;

const DeleteDummyDataModal = (props) => {
    if (!props.show_modal) return null;

    const handleClose = () => {
        props.setShow_modal(false);
    };

    const submitButton = () => {
        console.log('Delete Dummy Data');
        DeleteDummyData();
        props.setShow_modal(false)
    }


    const DeleteDummyData = () => {
        props.onDeleteDummyData().then((response) => {
            if (response.success === true) {
                toast.success(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                props.setShow_modal(false);
                
            } else {
                toast.error(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        })
    }

    return (
        <>
            <Modal
                animation={false}
                className='shake_modal'
                show={props.show_modal}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Dummy Data</Modal.Title>
                </Modal.Header>
                <Modal.Body className='text-center'>
                    <p>Are you sure you want to delete the dummy data ?</p>
                    <p className='m-0'>Changes you want will not be saved.</p>
                </Modal.Body>
                <Modal.Footer className='justify-content-center border-0'>
                    <Button variant="secondary" size="sm" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={submitButton} size="sm" >Delete</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    onDeleteDummyData: userActions.DeleteDummyData,
};
export default connect(mapStateToProps, mapDispatchToProps)(DeleteDummyDataModal);
